module.exports = __webpack_public_path__ + "files/9e853f79da1403ce7dc4e6c4ad9610c1.png";